import React, { useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { getAnalytics, logEvent } from "firebase/analytics";
import PosedRouter from './components/PosedRouter.js'
import Header from './menu/header';
import Home from './pages/home';
import About from './pages/about';
import Team from './pages/team';
import Donate from './pages/donate';
import Projects from './pages/projects';
import Events from './pages/events';
import Jobs from './pages/jobs';
import ShoppingCartApp from './pages/shop';
import Contact from './pages/contact';
import FoodBaskets from './pages/projects/food_baskets';
import Bakery from './pages/projects/bakery';
import Women from './pages/projects/women_empowerment';
import Covid from './pages/projects/covid_drives';
import Food from './pages/projects/food_drives';
import Housing from './pages/projects/housing_project';
import Eid from './pages/projects/eid_clothing';
import Literacy from './pages/projects/literacy_events';
import Water from './pages/projects/water_distribution';
import Soup from './pages/projects/soup_kitchen';
import Closet from './pages/projects/uhf_closet';
import Zakat from './pages/zakat';
import Test from './pages/test';
import Udhiyah from './pages/projects/udhiyah.js';

// 404 page
import NotFound from './pages/404.js';
import ProjectDetail from './pages/ProjectDetail';
import EventDetail from './pages/EventDetail';

import HopeForYemen from './pages/events/hopeforyemen';
import HitsForHumanity from './pages/events/hitsforhumanity';


import { firebaseApp } from '../components/components/firebase';

function usePageViews() {
  useEffect(() => {
    const analytics = getAnalytics(firebaseApp);
    logEvent(analytics, 'page_view', {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title
    });
  }, []);
}

const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

export default () => {
  usePageViews();

  return (
    <div className="wraper">
      <Header/>
      <ScrollTop />
      <PosedRouter>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/events" element={<Events />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/shop" element={<ShoppingCartApp />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects/food_baskets" element={<FoodBaskets />} />
        <Route path="/projects/bakery" element={<Bakery />} />
        <Route path="/projects/women_empowerment" element={<Women />} />
        <Route path="/projects/covid_drives" element={<Covid />} />
        <Route path="/projects/food_drives" element={<Food />} />
        <Route path="/projects/housing" element={<Housing />} />
        <Route path="/projects/eid_clothing" element={<Eid />} />
        <Route path="/projects/literacy_events" element={<Literacy />} />
        <Route path="/projects/water_distribution" element={<Water />} />
        <Route path="/projects/soup_kitchen" element={<Soup />} />
        <Route path="/projects/uhf_closet" element={<Closet />} />
        <Route path="/zakat_alfitr" element={<Zakat />} />
        <Route path="/events/hopeforyemen" element={<HopeForYemen />} />
        <Route path="/events/hitsforhumanity" element={<HitsForHumanity />} />
        {/* Dynamic route — remove static event routes above once migrated to Sanity */}
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route path="/projects/udhiyah" element={<Udhiyah />} />
        {/* Dynamic route — catches any /projects/:slug not matched above.
            Remove the static routes above once content is migrated to Sanity. */}
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/private/test" element={<Test />} />
        <Route path="*" element={<NotFound />} />
      </PosedRouter>
    </div>
  );
};
